module.exports = __webpack_public_path__ + "media/images/logo-c42-833133911c180df293ccb3790577b007.png";